import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { caseFileAPI, jobAPI, noteAPI } from '../api/api';
import TakvimGorunumu from '../components/Takvim/TakvimGorunumu';

/*
  TAKVIM SAYFASI
  --------------
  Yalnizca veriyi yukler; gorunumun tamami components/Takvim altinda.
  Boyle ayrildi ki ayni gorunum giris yapmadan ornek veriyle
  onizlenebilsin (gelistirme ortaminda /takvim-onizleme).

  Eski takvim (Ay / Ajanda / Hafta / Durusmalar gorunumleri, gunlerde
  yalnizca renkli noktalar) 2026-09-30'da kullanici istegiyle yeniden
  yazildi; git gecmisinde duruyor.
*/
const Calendar = () => {
  const { token } = useAuth();
  const navigate = useNavigate();
  const [dosyalar, setDosyalar] = useState([]);
  const [isler, setIsler] = useState([]);
  const [notlar, setNotlar] = useState([]);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [hata, setHata] = useState('');

  const yukle = useCallback(async () => {
    setYukleniyor(true);
    setHata('');
    try {
      const [d, i, n] = await Promise.all([
        caseFileAPI.getAll(),
        jobAPI.getAll().catch(() => []),
        noteAPI.getMyNotes().catch(() => []),
      ]);
      setDosyalar(d || []);
      setIsler(i || []);
      setNotlar(n || []);
    } catch (err) {
      setHata(err?.response?.data?.message || 'Takvim yüklenemedi. Lütfen sayfayı yenileyin.');
    } finally {
      setYukleniyor(false);
    }
  }, []);

  useEffect(() => { if (token) yukle(); }, [token, yukle]);

  if (hata) {
    return <div style={{ padding: 32, textAlign: 'center', color: '#8a2d24' }}>{hata}</div>;
  }

  return (
    <TakvimGorunumu
      dosyalar={dosyalar}
      isler={isler}
      notlar={notlar}
      yukleniyor={yukleniyor}
      onDosyaAc={(id) => navigate(`/case-files/${id}`)}
      onIsAc={(o) => navigate(o.dosyaId ? `/case-files/${o.dosyaId}` : '/job-list')}
    />
  );
};

export default Calendar;
